import { Dimensions, Platform } from 'react-native'
import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import { dimensions, styles } from './LoadingConfig.styles';

let dashboardLoadingConfig = {}

if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
  dashboardLoadingConfig = {
    mainCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.mainCard[0].circle,
          styles.mainCard[0].circle
        ),
        main: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[0].lineOne,
          styles.mainCard[0].lineOne
        ),
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[0].lineTwo,
          styles.mainCard[0].lineTwo
        ),
        style: styles.mainCard[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[1].line,
          styles.mainCard[1].line
        ),
        right: null,
        style: styles.mainCard[1].style
      },
      {
        left: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[2].line,
          styles.mainCard[2].line
        ),
        main: null,
        right: null
      }
    ],
    secCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.secCard[0].circle,
          styles.secCard[0].circle
        ),
        main: null,
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.secCard[0].line,
          styles.secCard[0].line
        ),
        style: styles.secCard[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          5,
          dimensions.secCard[1].line,
          styles.secCard[1].line
        ),
        right: null
      }
    ],
    adCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.adCards[0].circle,
          styles.adCards[0].circle
        ),
        main: null,
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.adCards[0].line,
          styles.adCards[0].line
        ),
        style: styles.adCards[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          1,
          dimensions.adCards[1].line,
          styles.adCards[1].line
        ),
        right: null
      }
    ]
  }
} else {
  dashboardLoadingConfig = {
    mainCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.mainCard[0].circle,
          styles.mainCard[0].circle
        ),
        main: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[0].lineOne,
          styles.mainCard[0].lineOne
        ),
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[0].lineTwo,
          styles.mainCard[0].lineTwo
        ),
        style: styles.mainCard[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          3,
          dimensions.mainCard[1].line,
          styles.mainCard[1].line
        ),
        right: null,
        style: styles.mainCard[1].style
      },
      {
        left: setLoadingConfigObject(
          'line',
          1,
          dimensions.mainCard[2].line,
          styles.mainCard[2].line
        ),
        main: null,
        right: null
      }
    ],
    secCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.secCard[0].circle,
          styles.secCard[0].circle
        ),
        main: null,
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.secCard[0].line,
          styles.secCard[0].line
        ),
        style: styles.secCard[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          5,
          dimensions.secCard[1].line,
          styles.secCard[1].line
        ),
        right: null
      }
    ],
    adCardsLoadingConfig: [
      {
        left: setLoadingConfigObject(
          'circle',
          1,
          dimensions.adCards[0].circle,
          styles.adCards[0].circle
        ),
        main: null,
        right: setLoadingConfigObject(
          'line',
          1,
          dimensions.adCards[0].line,
          styles.adCards[0].line
        ),
        style: styles.adCards[0].style
      },
      {
        left: null,
        main: setLoadingConfigObject(
          'line',
          1,
          dimensions.adCards[1].line,
          styles.adCards[1].line
        ),
        right: null
      }
    ]
  }
}

const discoverCardLoadingConfig = [
  {
    left: null,
    main: null,
    right: null,
  },
];

const lastUpdatedLoadingConfig = [
  {
    main: null,
    left: setLoadingConfigObject(
      'line',
      1,
      dimensions.lastUpdated[0].line,
      styles.lastUpdated[0].line,
    ),
    right: null,
  },
];

export {
  dashboardLoadingConfig,
  discoverCardLoadingConfig,
  lastUpdatedLoadingConfig,
  shimmerPlaceholderConfig,
};
